@if (showNudge) {
<div class="snackbar-container">
  <div class="snackbar">
    <img
      class="warning_icon"
      src="assets/images/Icons/⚛️ icons-warning-outline.svg"
      alt="warning"
      [attr.aria-label]="'Warning' | globalTranslate"
    />
    <div class="white-space" [innerHTML]="message"></div>
    <button class="snackclose" type="submit" (click)="closeSnackBar()">
      <img
        class="close_icon"
        src="../../../assets/images/close-circle-svgrepo-com (1).svg"
        alt="close-icon"
        [attr.aria-label]="'CLOSE' | globalTranslate"
      />
    </button>
  </div>
</div>
}